import { z } from 'zod';
// Request and response schemas for the API layer
export const FindPersonByIdRequestDTOSchema = z.object({
    params: z.object({
        companyId: z.string().uuid(),
        personId: z.string().uuid(),
    }),
});
//# sourceMappingURL=find-person-by-id.dto.js.map